import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-search-control',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="flex items-center space-x-3" [class.pr-3]="!removePadding"
        [formGroup]="searchForm" 
        (keydown)="onKeyDown($event)">
      <div class="orange-text text-xs">Search:</div>
      <div style="position: relative; display: flex; align-items: center;">
        <input 
          class="orange-input focus:outline-none pl-1 text-xs p-1"
          style="padding-right: 18px;"
          type="text"
          [placeholder]="searchPlaceholder"
          formControlName="search"
          (keyup)="onSearchKeyup($event)"
        >
        <span
          *ngIf="searchForm.get('search').value"
          (click)="clearSearch()"
          style="
            position: absolute;
            right: 8px;
            cursor: pointer;
            font-size: 13px;
            color: #999;
            line-height: 1;
            user-select: none;
          "
          class="material-icons"
        >
          search_off
        </span>
      </div>
    </div>
  `
})
export class SearchControlComponent {
  @Input() searchPlaceholder = 'Search';
  @Input() removePadding = false;
  @Output() searchKeyupEvent = new EventEmitter<any>();
  @Output() keydownEvent = new EventEmitter<any>();

  searchForm: UntypedFormGroup;

  constructor(private fb: FormBuilder) {
    this.searchForm = this.fb.group({
      search: ['']
    });
  }

  onSearchKeyup(event: any): void {
    this.searchKeyupEvent.emit(event);
  }

  onKeyDown(event: any): void {
    this.keydownEvent.emit(event);
  }

  clearSearch(): void {
    this.searchForm.patchValue({ search: '' });
    this.searchKeyupEvent.emit({ target: { value: '' } });
  }
}
